import Index from '@/views/penalties/Index'

export default [
  {
    path: ':clientId/penalties',
    name: 'penalties.index',
    component: Index
  }
]
